// @flow
import React, { Component } from "react";

type PropsType = {
  translate: string => void
};

type StateType = {};

class MissionUnit extends Component<PropsType, StateType> {
  render() {
    const { translate } = this.props;
    return (
      <section id="section-mission" className="section">
        <div className="container">
          <div className="row gap-y align-items-center">

            <div className="col-md-8 mx-auto">
              <h2>{translate("AboutPageLocale.mission.header.title")}</h2>
              <p className="lead">{translate("AboutPageLocale.mission.header.content")}</p>

              <br/>

              <p>
                <i className="fas fa-check text-success mr-2"></i>
                <span>{translate("AboutPageLocale.mission.items.one")}</span>
              </p>

              <p>
                <i className="fas fa-check text-success mr-2"></i>
                <span>{translate("AboutPageLocale.mission.items.two")}</span>
              </p>

              <p>
                <i className="fas fa-check text-success mr-2"></i>
                <span>{translate("AboutPageLocale.mission.items.three")}</span>
              </p>

              <p>
                <i className="fas fa-check text-success mr-2"></i>
                <span>{translate("AboutPageLocale.mission.items.four")}</span>
              </p>
            </div>

          </div>
        </div>
      </section>
    );
  }
}

export default MissionUnit;


// WEBPACK FOOTER //
// ./src/Components/PublicPages/Components/AboutPage/MissionUnit.js